import React from 'react';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Privacy Policy - RMQ Digital</title>
        <meta name="description" content="RMQ Digital privacy policy. Learn how we collect, use, and protect your information." />
      </Helmet>
      
      <section style={{padding: '4rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', color: '#1f2937', fontFamily: 'Space Grotesk'}}>Privacy Policy</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic', color: '#6b7280'}}>
              <strong>Last Updated:</strong> December 1, 2025
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Introduction</h2>
            <p style={{marginBottom: '2rem'}}>
              RMQ HOLDINGS INC, operating as RMQ Digital ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our 
              business communication services.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Information We Collect</h2>
            <h3 style={{color: '#374151', marginBottom: '0.5rem', fontSize: '1.25rem'}}>Business Contact Information</h3>
            <p style={{marginBottom: '1rem'}}>We may collect:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Business contact information (email, phone number, address)</li>
              <li>Company name and business information</li>
              <li>Account details and preferences</li>
              <li>Communication preferences and consent records</li>
              <li>Device and browser information</li>
              <li>Message delivery data</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>How We Use Your Information</h2>
            <p style={{marginBottom: '1rem'}}>We use collected information for:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Providing customer communication services</li>
              <li>Managing and delivering notifications and alerts</li>
              <li>Communicating with you about services</li>
              <li>Improving our services and platform</li>
              <li>Ensuring compliance with applicable laws and regulations</li>
              <li>Providing customer support</li>
              <li>Processing transactions</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>SMS and Email Consent</h2>
            <div style={{background: '#ede9fe', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <p style={{fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem'}}>
                Consent Disclosure:
              </p>
              <p style={{color: '#5b21b6', marginBottom: '1rem'}}>
                By providing your contact information and consent, you agree to receive communications from RMQ Digital regarding your account and services.
                <strong> Message frequency varies. Message and data rates may apply.</strong> Reply STOP to opt out.
              </p>
              <p style={{fontSize: '0.95rem', color: '#6d28d9', fontWeight: '600'}}>
                Your consent to receive messages is not required as a condition of purchasing any goods or services. 
                Consent is not transferable and will not be sold, shared, or rented to third parties for their own purposes.
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Information Sharing</h2>
            <p style={{marginBottom: '1rem'}}>We share information only in the following circumstances:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Service Providers:</strong> Technical vendors who assist in platform operations and message delivery</li>
              <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process</li>
              <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales</li>
              <li><strong>Consent:</strong> With your explicit consent for specific purposes</li>
            </ul>
            <p style={{marginBottom: '2rem', fontWeight: '600', color: '#6d28d9'}}>
              We do not sell, rent, or share customer data with third parties for their marketing purposes.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Data Security</h2>
            <p style={{marginBottom: '1rem'}}>We implement comprehensive security measures:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Encryption of data in transit and at rest</li>
              <li>Secure data centers with access controls</li>
              <li>Regular security audits and monitoring</li>
              <li>Employee training on data protection</li>
              <li>Multi-factor authentication for account access</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Your Rights and Choices</h2>
            <p style={{marginBottom: '1rem'}}>You have the following rights:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Opt-out:</strong> Unsubscribe from communications at any time</li>
              <li><strong>Consent Withdrawal:</strong> Withdraw consent for specific processing</li>
              <li><strong>Data Portability:</strong> Request a copy of your data</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Cookies and Tracking</h2>
            <p style={{marginBottom: '2rem'}}>
              We use cookies and similar tracking technologies to improve user experience, analyze website traffic, and deliver personalized content. 
              You can control cookie preferences through your browser settings.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Children's Privacy</h2>
            <p style={{marginBottom: '2rem'}}>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. 
              If you believe we have collected information from a child, please contact us immediately.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Data Retention</h2>
            <p style={{marginBottom: '2rem'}}>
              We retain personal information only as long as necessary to provide services, comply with legal obligations, 
              resolve disputes, and enforce our agreements.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Changes to This Policy</h2>
            <p style={{marginBottom: '2rem'}}>
              We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on our website 
              and updating the "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the updated policy.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Contact Information</h2>
            <div style={{background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb'}}>
              <p style={{fontWeight: '600', marginBottom: '1rem'}}>RMQ HOLDINGS INC</p>
              <p><strong>DBA:</strong> RMQ Digital</p>
              <p>2022 EAST 9TH STREET<br />BROOKLYN, NY 11223<br />United States</p>
              <p><strong>Owner:</strong> MOSHE QUBRUSI</p>
              <p><strong>EIN:</strong> 99-1828959</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> privacy@rmqdigital.com</p>
              <p><strong>Support:</strong> support@rmqdigital.com</p>
              <p style={{marginTop: '1rem', fontSize: '0.9rem', color: '#6b7280'}}>
                For privacy-related inquiries, please email us or use our contact form.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
